export default __webpack_public_path__ + "static/media/iquippo-website.371a5b14.svg";